import { useNavigate, useParams } from 'react-router-dom'

import { ExportSidepanel } from 'modules/universal_exports/components/ExportSidepanel'

const SaleInvoicesExporterSidePanel = () => {
  const navigate = useNavigate()
  const { id } = useParams()
  const projectId = Number(id)

  return (
    <ExportSidepanel
      resource="finance.financial_document"
      overrideFilters={{ operation_type: ['sale'], project_id: [projectId] }}
      onClose={() => navigate(-1)}
    />
  )
}

export default SaleInvoicesExporterSidePanel
